import { CreateClubRequest } from '../generated'

// Passwordless sign-in navigates the browser away (email round-trip) and back to
// the completion route, so the sign-up intent that must survive the hop is
// stashed in localStorage.

// Where the Firebase email link returns the user. Both the sender and the
// completion route must agree on this path.
export const COMPLETE_SIGN_UP_PATH = '/complete-sign-up'

const STORAGE_KEY = 'speechAgenda.signUpDraft'

export interface SignUpDraft {
  email: string
  displayName: string
  // Present only for the register-club flow; the completion route creates the
  // club when it's set. Standalone sign-up leaves it undefined.
  club?: CreateClubRequest
  // Where to land the user once provisioning settles (standalone sign-up's
  // `?next=` target). Defaults applied by the completion route.
  next?: string
}

export function saveSignUpDraft(draft: SignUpDraft): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(draft))
  } catch {
    // Ignore storage failures (private mode, quota) — the completion route will
    // surface the missing-draft error instead.
  }
}

export function loadSignUpDraft(): SignUpDraft | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as SignUpDraft
  } catch {
    return null
  }
}

export function clearSignUpDraft(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Nothing actionable if removal fails.
  }
}
